<template>
  <b-overlay
    id="overlay-background"
    :show="show"
    variant="primary"
    opacity="0.85"
    blur="2"
    rounded="sm"
  >
    <b-card>
      <validation-observer ref="simpleRules">
        <b-form class="mt-2">
          <b-row>
            <b-col sm="6">
              <b-form-group label="Adı" label-for="account-username">
                <validation-provider
                  #default="{ errors }"
                  name="First Name"
                  rules="required"
                >
                  <b-form-input
                    id="input-live"
                    v-model="addAddressRequestModel.title"
                    placeholder="Adı"
                    :state="errors.length > 0 ? false : null"
                    name="username"
                  />
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group label="Kısa" label-for="account-name">
                <validation-provider
                  #default="{ errors }"
                  name="First Name"
                  rules="required"
                >
                  <b-form-input
                    v-model="addAddressRequestModel.address2"
                    name="name"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Kısa"
                  />
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col sm="4">
              <b-form-group label="Şehir" label-for="account-name">
                <validation-provider
                  #default="{ errors }"
                  name="First Name"
                  rules="required"
                >
                  <b-form-input
                    v-model="addAddressRequestModel.town"
                    name="name"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Şehir"
                  />
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col sm="8">
              <b-form-group label="Adres" label-for="account-name">
                <validation-provider
                  #default="{ errors }"
                  name="First Name"
                  rules="required"
                >
                  <b-form-input
                    v-model="addAddressRequestModel.address"
                    name="name"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Adres"
                  />
                </validation-provider>
              </b-form-group>
            </b-col>
            <!--/ alert -->

            <b-col cols="12">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="mt-2 mr-1"
                @click.prevent="savePerson"
              >
                Kaydet
              </b-button>
              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                variant="outline-secondary"
                type="reset"
                class="mt-2"
                @click.prevent="resetForm"
              >
                Temizle
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
      <br />
      <b-table
        :striped="true"
        :bordered="true"
        :hover="true"
        :small="true"
        ref="refUserListTable"
        class="position-relative"
        :items="persons"
        responsive
        :fields="tableColumns"
        primary-key="id"
        sort-by.sync="id"
        show-empty
        empty-text="Kayıt bulunamadı."
        head-variant="dark"
      >
      </b-table>
    </b-card>
  </b-overlay>
</template>

<script>
import {
  BFormFile,
  BButton,
  BForm,
  BTable,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BAlert,
  BCard,
  BCardText,
  BMedia,
  BMediaAside,
  BOverlay,
  BMediaBody,
  BLink,
  BImg,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import Ripple from "vue-ripple-directive";
import { required, email } from "@validations";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
export default {
  components: {
    BButton,
    BForm,
    ValidationProvider,
    ValidationObserver,
    BImg,
    ToastificationContent,
    BFormFile,
    BFormGroup,
    BFormInput,
    BOverlay,
    BRow,
    BCol,
    BAlert,
    BCard,
    BCardText,
    BMedia,
    BTable,
    BMediaAside,
    BMediaBody,
    BLink,
  },
  directives: {
    Ripple,
  },
  props: {
    generalData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      addAddressRequestModel: {},
      persons: [],
      tableColumns: [
        { key: "title", label: "Adı" },
        { key: "address", label: "Adres" },
        { key: "district", label: "Adres 2" },
        { key: "town", label: "Şehir" },
        { key: "type", label: "Adres Tipi" },
      ],
      required,
      email,
    };
  },
  created() {
    this.init();
  },
  methods: {
    resetForm() {
      this.addAddressRequestModel = {};
    },
    savePerson() {
      this.$refs.simpleRules.validate().then((success) => {
        if (success) {
          this.show = true;
          this.$http
            .post("User/AddDealerContact", this.addDealerRequestModel)
            .then((response) => {
              this.init();
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Başarılı",
                  icon: "UserIcon",
                  text: response.data.message,
                  variant: "success",
                },
              });
            })
            .catch((error) => {
              this.show = false;

              this.$swal({
                title: "Hata!",
                text: error.response.data.responseException.exceptionMessage,
                icon: "error",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                confirmButtonText: "Kapat",
                buttonsStyling: false,
              });
            });
        } else {
          this.$swal({
            title: "Hata!",
            text: "Lütfen tüm alanları doldurduğunuzdan emin olunuz.",
            icon: "error",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            confirmButtonText: "Kapat",
            buttonsStyling: false,
          });
        }
      });
    },
    init() {
      this.show = true;
      this.$http
        .get("/User/GetDealerAddress")
        .then((response) => {
          this.persons = response.data.result;
          this.show = false;
        })
        .catch((error) => {
          this.show = false;

          this.$swal({
            title: "Hata!",
            text: error.response.data.responseException.exceptionMessage,
            icon: "error",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            confirmButtonText: "Kapat",
            buttonsStyling: false,
          });
        });
    },
  },
};
</script>
